<template>
  <div>
    <v-snackbar
      v-model="habilitar"
      :timeout="-1"
      :color="cor"
    >
      <div class="text-h6 font-weight-medium">{{ texto }}</div>
      <template v-slot:action="{ attrs }">
        <v-btn v-bind="attrs" text @click="closeEvent">
          Fechar
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  props: {
    habilitar: Boolean,
    texto: String,
    cor: String
  },

  methods: {
    closeEvent() {
      this.$emit("snack-close");
    },
  },
};
</script>
